import React, {
  useCallback, useEffect, useRef, useState,
} from 'react';
import {
  FaChevronLeft, FaChevronRight, FaFileAlt, FaUserShield, FaRegCheckCircle, FaMinus,
} from 'react-icons/fa';
import {
  makeStyles, Theme, createStyles, withStyles,
} from '@material-ui/core/styles';
import clsx from 'clsx';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepConnector from '@material-ui/core/StepConnector';
import Typography from '@material-ui/core/Typography';
import { StepIconProps } from '@material-ui/core/StepIcon';
import { useHistory, useParams } from 'react-router-dom';
import { FormControlLabel, Switch } from '@material-ui/core';
import { useToast } from 'hooks/toast';
import {
  TrashIcon, CarIcon, UserFriends, Handcuffs, PlusIcon, PencilIcon,
} from 'styles/icons';
import { IOccurrence } from 'interfaces';
import Label from 'components/Label';
import { formatDateTime } from 'utils';
import { toInteger } from 'lodash';
import { BiCheck, BiExit } from 'react-icons/bi';
import isEmptyObject from 'utils/emptyObject';
import Modal from '../../../components/ModalSimple';
import { Grid } from '../../../components/Flex';
import Layout from '../../../components/Layout';
import { Button as ButtonMat } from '../../../components/Forms';
import { useAuth } from '../../../hooks/auth';
import { useHttp } from '../../../hooks/http';
import { WrapperGrid, WrapperName } from '../styles';

import {
  Container,
  Button,
  WrapperAddress,
  Title,
  StepperContainer,
  WrapperModal,
  Red,
  WrapperModalDelete,
  TitleModal,
  StepperContainerIcon,
} from './styles';

interface IStatus {
  involved: string,
  civilPolice: string,
  carInvolved: string,
  seizure: string,
}

const useStyles = makeStyles((theme: Theme) => createStyles({
  root: {
    width: '100%',
  },
  button: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
}));

const CustomizedSteppers: React.FC = () => {
  const getSteps = (): any => ['', '', '', '', ''];
  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);
  const steps = getSteps();
  const history = useHistory();
  const { addToast } = useToast();

  const [status, setStatus] = useState<IStatus>();
  const { httpGet, httpDelete } = useHttp();
  const labelConfRef = useRef<HTMLLabelElement>(null);
  const labelConfRefDelete = useRef<HTMLLabelElement>(null);
  const switchs = useRef<HTMLLabelElement>(null);
  const switchsDelete = useRef<HTMLLabelElement>(null);
  const [occurrence, setOccurrence] = useState({} as IOccurrence);
  const [btnLoading, setBtnLoading] = useState(false);
  const [disableBtn, setDisableBtn] = useState(false);
  const [isloadding, setIsloadding] = useState(true);
  const [btnLoadingDelete, setBtnLoadingDelete] = useState(false);
  const [disableBtnDelete, setDisableBtnDelete] = useState(false);
  const [RI, setRI] = useState(false);
  const { user } = useAuth();
  const { step } = useParams<{ step: string }>();
  const [ref] = occurrence.id ? occurrence.id?.split('-') : '';
  localStorage.setItem('bopmId', `${occurrence?.id}`);

  useEffect(() => {
    async function loadStatus(): Promise<any> {
      const { data } = await httpGet(`/bopms/status/${occurrence.id}`);
      setStatus(data);
      setActiveStep(toInteger(step));
    }
    occurrence.id && loadStatus();
  }, [httpGet, occurrence, step]);

  useEffect(() => {
    async function load(): Promise<any> {
      const { status, data } = await httpGet('/bopms/simpleDetail');

      if (status === 200) {
        setOccurrence(data);
        setIsloadding(false);
        setRI(data?.type_of_registration === 'RI');
      } else {
        setIsloadding(false);
        history.push('/bopm/occurrence/storage');
      }
    }
    load();
  }, [history, httpGet, user]);

  const handleCloseBopm = useCallback(async (bopmId) => {
    setBtnLoading(false);
    const response: any = await httpGet(`/bopms/close/${bopmId}`);

    // eslint-disable-next-line no-constant-condition
    if (response.status === 200 || 204) {
      addToast({ title: `Seu BOPM: ${response.data}`, type: 'success' });
      history.push('/bopm/list');
    } else {
      addToast({ title: 'Não foi possível excluir!', type: 'error' });
      setBtnLoading(false);
      setDisableBtn(false);
    switchs.current?.click();
    labelConfRef.current?.click();
    }
  }, [addToast, history, httpGet]);

  const handleDeleteBopm = useCallback(async (bopmId) => {
    setBtnLoading(false);

    const response: any = await httpDelete(`/bopms/${bopmId}`);

    // eslint-disable-next-line no-constant-condition
    if (response.status === 200 || 204) {
      addToast({ title: 'Seu BOPM foi deletado com sucesso ', type: 'success' });
      history.push('/dashboard');
    } else {
      addToast({ title: 'Não foi possível excluir!', type: 'error' });
      setBtnLoadingDelete(false);
      setDisableBtnDelete(false);
    switchsDelete.current?.click();
    labelConfRefDelete.current?.click();
    }
  }, [addToast, history, httpDelete]);

  const ColorlibConnector = withStyles({
    alternativeLabel: {
      top: 22,
    },
    active: {
      '& $line': {
        backgroundImage:
      'linear-gradient( 136deg, rgb(211, 209, 208) 0%, rgb(165, 163, 164) 50%, rgb(150, 147, 150) 100%)',
      },
    },
    completed: {
      '& $line': {
        backgroundImage:
      'linear-gradient( 136deg, rgb(134, 129, 126) 0%, rgb(117, 115, 116) 50%, rgb(102, 99, 102) 100%)',
      },
    },
    line: {
      height: 3,
      border: 0,
      backgroundColor: '#eaeaf0',
      borderRadius: 1,
    },
  })(StepConnector);

  const useColorlibStepIconStyles = makeStyles({
    root: {
      backgroundColor: '#ccc',
      zIndex: 1,
      color: '#fff',
      width: 45,
      height: 45,
      display: 'flex',
      borderRadius: '50%',
      justifyContent: 'center',
      alignItems: 'center',
    },
    active: {
      backgroundImage:
      'linear-gradient( 136deg, rgb(255, 255, 255) 0%, rgb(231, 225, 227) 50%, rgb(184, 175, 184) 100%)',
      boxShadow: '0 4px 10px 0 rgba(255, 253, 253, 0.25)',
      color: '#39393a',
      border: 'solid 2px rgb(150, 147, 150)',
    },
    completed: {
      backgroundImage:
    'linear-gradient( 136deg, rgb(134, 129, 126) 0%, rgb(70, 67, 68) 50%, rgb(63, 61, 63) 100%)',
    },
  });

  const ColorlibStepIcon = (props: StepIconProps): any => {
    const classes = useColorlibStepIconStyles();
    const { active, completed } = props;

    const icons: { [index: string]: React.ReactElement } = {
      1: <FaFileAlt />,
      2: <UserFriends />,
      3: <FaUserShield />,
      4: <CarIcon />,
      5: <Handcuffs />,
    };

    return (
      <div
        className={clsx(classes.root, {
          [classes.active]: active,
          [classes.completed]: completed,
        })}
      >
        {icons[String(props.icon)]}
      </div>
    );
  };

  const getStepContent = (step: number): any => {
    switch (step) {
      case 0:
        return 'Ocorrência';
      case 1:
        return 'Envolvidos';
      case 2:
        return 'Autoridade Policial';
      case 3:
        return 'Veículos Envolvidos';
      case 4:
        return 'Apreenções';
      default:
        return 'Unknown step';
    }
  };
  const handleGoToDetail = useCallback(async () => {
  labelConfRef.current?.click();
  }, []);

  const handleGoToDetailDelete = useCallback(async () => {
  labelConfRefDelete.current?.click();
  }, []);

  const handleChangeChecked = useCallback(async (event: React.ChangeEvent<HTMLInputElement>) => {
    setDisableBtn(event.target.checked);
  }, []);

  const handleChangeCheckedDelete = useCallback(
    async (event: React.ChangeEvent<HTMLInputElement>) => {
      setDisableBtnDelete(event.target.checked);
    }, [],
  );

  const handleHover = useCallback(() => {
    setBtnLoading(false);
    setDisableBtn(false);
  switchs.current?.click();
  labelConfRef.current?.click();
  }, []);

  const handleHoverDelete = useCallback(() => {
    setBtnLoadingDelete(false);
    setDisableBtnDelete(false);
  switchsDelete.current?.click();
  labelConfRefDelete.current?.click();
  }, []);

  const handleNext = (): void => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = (): void => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const breadcrumbs = {
    icon: FaFileAlt,
    links: [{ path: '/bopm/list', title: 'Bopm' }],
  };

  return (
    <Layout breadcrumbs={breadcrumbs}>
      {isloadding ? <p>Loading...</p> : (
        <>
          {RI === false
        && (
        <Stepper alternativeLabel activeStep={activeStep} connector={<ColorlibConnector />}>
          {steps.map((label: string) => (
            <Step key={label}>
              <StepLabel StepIconComponent={ColorlibStepIcon}>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
        )}
          <WrapperAddress>
            <Container>
              {activeStep === steps.length ? (
                <div>
                  <Typography className={classes.instructions}>
                    <span>Todas as etapas concluídas - Agora você pode:</span>
                    <p>1- <b>Voltar</b> - Adicionar mais informações ao BOPM;</p>
                    <p>2- <b>Sair</b> - Para concluir o BOPM mais tarde;</p>
                    <p>3- <b>Encerrar</b> - Concluir definitivamente o BOPM.</p>
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={4} md={4}>
                      <Button
                        disabled={activeStep === 0}
                        onClick={handleBack}
                        className={classes.button}
                      >
                        <FaChevronLeft /> Volta
                      </Button>
                    </Grid>
                    <Grid item xs={12} sm={4} md={4}>
                      <Button onClick={() => { history.push('/dashboard'); }}>
                        Sair <BiExit />
                      </Button>
                    </Grid>
                    <Grid item xs={12} sm={4} md={4}>
                      <Button onClick={() => { handleGoToDetail(); }} className={classes.button}>
                        Encerrar<BiCheck />
                      </Button>
                    </Grid>
                  </Grid>
                </div>
              ) : (
                <>
                  <Title className={classes.instructions}>{RI === false ? `${getStepContent(activeStep)}` : 'Registro Interno'}</Title>
                  <Grid container spacing={1}>
                    {`${getStepContent(activeStep)}` === 'Ocorrência' && (
                    <>

                      <Grid item xs={12} sm={8} md={8}>
                        <WrapperGrid>
                          <WrapperName>
                            <FaFileAlt />&nbsp;{`${occurrence?.type_of_registration} N°${occurrence.type_of_registration === 'RI'
                              ? ref : occurrence?.registration_number} ${RI === false ? ` - ${occurrence?.dp}` : ''}`}
                          </WrapperName>
                          <Grid container spacing={1}>
                            <Label title="Base:" xs={12} md={12}>
                              {occurrence?.base}
                            </Label>

                            <Label title={RI === false ? 'Tipo de Mandado:' : 'Tipo:'} xs={12} md={6}>
                              <label>{occurrence?.type_of_warrant} </label>
                            </Label>

                            <Label title={RI === false ? 'Iniciado a Ocorrencia' : 'Iniciado o Registro'} xs={12} md={6}>
                              {occurrence?.origin_of_occurrence}
                            </Label>

                            <Label title="Data/Hora do fato:" xs={12} md={6}>
                              {formatDateTime(occurrence?.started_at)}
                            </Label>

                            <Label title="Término:" xs={12} md={6}>
                              {occurrence?.exit_dp ? (formatDateTime(occurrence?.exit_dp)) : ('Aguardando Término...')}
                            </Label>
                          </Grid>
                        </WrapperGrid>
                      </Grid>

                        {occurrence?.order_id && !isEmptyObject(occurrence?.order_id) ? (
                          <Grid item xs={6} sm={2} md={2}>
                            <StepperContainerIcon onClick={() => handleGoToDetailDelete()}>
                              <TrashIcon />
                            </StepperContainerIcon>
                          </Grid>
                        ) : ''}

                      <Grid item xs={6} sm={2} md={2}>
                        <StepperContainerIcon onClick={() => { history.push(`/bopm/occurrence/${occurrence?.id}`); }}>
                          <PencilIcon />
                        </StepperContainerIcon>
                      </Grid>
                    </>
                    )}
                    <Grid item xs={12} sm={2} md={4} />
                    <Grid item xs={6} sm={4} md={2}>

                      {`${getStepContent(activeStep)}` === 'Envolvidos' && status?.involved !== '00' && (
                      <StepperContainer onClick={() => { history.push('/bopm/involveds/show'); }}>
                        <span><PencilIcon /></span>
                        <UserFriends />
                        Editar
                        <b>{status?.involved}</b>
                      </StepperContainer>
                      )}
                      {`${getStepContent(activeStep)}` === 'Autoridade Policial' && status?.civilPolice !== '00' && (
                      <StepperContainer onClick={() => { history.push('/bopm/polices/show'); }}>
                        <span><PencilIcon /></span>
                        <FaUserShield />
                        Editar
                        <b>{status?.civilPolice}</b>
                      </StepperContainer>
                      )}
                      {`${getStepContent(activeStep)}` === 'Veículos Envolvidos' && status?.carInvolved !== '00' && (
                      <StepperContainer onClick={() => { history.push('/bopm/carInvolved/show'); }}>
                        <span><PencilIcon /></span>
                        <CarIcon />
                        Editar
                        <b>{status?.carInvolved}</b>
                      </StepperContainer>
                      )}
                      {`${getStepContent(activeStep)}` === 'Apreenções' && status?.seizure !== '00' && (
                      <StepperContainer onClick={() => { history.push('/bopm/seizures/show'); }}>
                        <span><PencilIcon /></span>
                        <Handcuffs />
                        Editar
                        <b>{status?.seizure}</b>
                      </StepperContainer>
                      )}
                    </Grid>
                    <Grid item xs={6} sm={4} md={2}>
                      {`${getStepContent(activeStep)}` === 'Envolvidos' && (
                      <StepperContainer onClick={() => { history.push('/bopm/involved/storage'); }}>
                        <span><PlusIcon /></span>
                        <UserFriends />
                        Adicionar
                      </StepperContainer>
                      )}
                      {`${getStepContent(activeStep)}` === 'Autoridade Policial' && (
                      <StepperContainer onClick={() => { history.push('/bopm/polices/storage'); }}>
                        <span><PlusIcon /></span>
                        <FaUserShield />
                        Adicionar
                      </StepperContainer>
                      )}
                      {`${getStepContent(activeStep)}` === 'Veículos Envolvidos' && (
                      <StepperContainer onClick={() => { history.push('/bopm/carInvolved/storage'); }}>
                        <span><PlusIcon /></span>
                        <CarIcon />
                        Adicionar
                      </StepperContainer>
                      )}
                      {`${getStepContent(activeStep)}` === 'Apreenções' && (
                      <StepperContainer onClick={() => { history.push('/bopm/seizures/storage/menu'); }}>
                        <span><PlusIcon /></span>
                        <Handcuffs />
                        Adicionar
                      </StepperContainer>
                      )}
                    </Grid>
                    <Grid item xs={12} sm={2} md={4} />
                  </Grid>
                  <span style={{ display: 'flex', gap: 8, marginTop: 45 }}>
                    <Grid container spacing={1}>
                      { RI === false ? (
                        <>
                          <Grid item xs={6} sm={4} md={4}>
                            <Button
                              disabled={activeStep === 0}
                              onClick={handleBack}
                              className={classes.button}
                            >
                              {activeStep !== 0 ? <FaChevronLeft /> : <FaMinus />}
                              {activeStep !== 0 && 'Voltar'}
                            </Button>
                          </Grid>
                          <Grid item xs={6} sm={4} md={4}>
                            <Button color="primary" onClick={handleNext} className={classes.button}>
                              Avançar <FaChevronRight />
                            </Button>
                          </Grid>
                        </>
                      )
                        : (
                          <Grid item xs={12} sm={4} md={4}>
                            <Button
                              onClick={() => { handleGoToDetail(); }}
                              className={classes.button}
                            >
                              Encerrar<BiCheck />
                            </Button>
                          </Grid>
                        )}
                      <Grid item xs={12} sm={4} md={4}>
                        <Button onClick={() => { history.push('/dashboard'); }}>
                          Sair <BiExit />
                        </Button>
                      </Grid>

                    </Grid>
                  </span>
                </>
              )}
            </Container>
          </WrapperAddress>
          <WrapperModal>
            <label ref={labelConfRef} htmlFor="modal-conf" />
            <Modal id="modal-conf" width={520} height="auto">
              <TitleModal>
                <p className="alert"><FaRegCheckCircle /> Deseja encerrar o {RI === true ? 'Registro' : 'BOPM'}?</p>
              </TitleModal>
              <p>
                <b>
                  {`${occurrence?.type_of_registration} N°${occurrence.type_of_registration === 'RI'
                    ? ref : occurrence?.registration_number} ${RI === false ? ` - ${occurrence?.dp}` : ''}`}
                </b>
              </p>
              <p> Base: <b>{occurrence?.base}</b></p>
              <p> Tipo {RI === false && 'de Mandado'}: <b>{occurrence?.type_of_warrant}</b> </p>
              <FormControlLabel
                ref={switchs}
                label={<Red>Confirmo as informações acima.</Red>}
                control={(
                  <Switch
                    onChange={handleChangeChecked}
                    color="primary"
                    name="checked"
                    value="false"
                    inputProps={{ 'aria-label': 'primary checkbox' }}
                  />
            )}
              />
              <span>
                <ButtonMat onClick={handleHover}>
                  Cancelar
                </ButtonMat>
                <ButtonMat
                  type="button"
                  onClick={() => { handleCloseBopm(occurrence?.id); }}
                  isLoading={btnLoading}
                  disableForce={!disableBtn}
                >
                  Encerrar
                </ButtonMat>
              </span>

            </Modal>
          </WrapperModal>

          <WrapperModalDelete>
            <label ref={labelConfRefDelete} htmlFor="modal-conf-delete" />
            <Modal id="modal-conf-delete" width={520} height="auto">

              <TitleModal>
                <p className="delete"> <TrashIcon /> Deseja excluir o {RI === true ? 'Registro' : 'BOPM'}?</p>
              </TitleModal>

              <p>
                <b>
                  {`${occurrence?.type_of_registration} N°${occurrence.type_of_registration === 'RI'
                    ? ref : occurrence?.registration_number} ${RI === false ? ` - ${occurrence?.dp}` : ''}`}
                </b>
              </p>
              <p> Base: <b>{occurrence?.base}</b></p>
              <p> Tipo {RI === false && 'de Mandado'}: <b>{occurrence?.type_of_warrant}</b> </p>
              <FormControlLabel
                ref={switchsDelete}
                label={<Red>Confirmo as informações acima.</Red>}
                control={(
                  <Switch
                    onChange={handleChangeCheckedDelete}
                    color="primary"
                    name="checked"
                    value="false"
                    inputProps={{ 'aria-label': 'primary checkbox' }}
                  />
            )}
              />
              <span>
                <ButtonMat onClick={handleHoverDelete}>
                  Cancelar
                </ButtonMat>
                <ButtonMat
                  type="button"
                  onClick={() => { handleDeleteBopm(occurrence?.id); }}
                  isLoading={btnLoadingDelete}
                  disableForce={!disableBtnDelete}
                >
                  Excluir
                </ButtonMat>
              </span>
            </Modal>
          </WrapperModalDelete>
        </>
      )}
    </Layout>
  );
};
export default CustomizedSteppers;
